import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  ElectionAmount,
  FlexListHeader,
  Inscription,
  ListItemBase,
} from '@common-fe/common-fe';
import { uniqueId } from 'lodash';
import styled from 'styled-components';

import currentTheme from '@/styles/theme';
import { formatCurrency } from '@/utils';

const Wrapper = styled(Box)`
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings.spacing8};
  }
`;

const ElectionAmountTable: React.FC<{
  electionAmounts: ElectionAmount[],
}> = ({ electionAmounts }) => {
  const { t } = useTranslation();
  const headers: ListItemBase[] = useMemo(() => {
    const currentHeaders = [
      {
        key: 'period',
        title: t('Period'),
        flex: 3,
      },
      {
        key: 'amount',
        title: t('Election Amount'),
        flex: 2,
      },
    ];
    return currentHeaders;
  }, [t]);

    const sortedElectionAmounts = useMemo(() => {
    return electionAmounts.sort((a, b) => new Date(b?.validFrom || 0).getTime() - new Date(a?.validFrom || 0).getTime());
  }, [electionAmounts]);

  return (
    <Box
      data-testId="election_amount_table"
      background="module"
      pad="xs"
      round="small"
      margin={{ vertical: 'xs' }}
    >
      <FlexListHeader items={headers} thinMode />
      {sortedElectionAmounts.map((item, index) => (
        <Wrapper
          key={uniqueId()}
          height="42px"
          background="canvas"
          elevation="default"
          round={currentTheme.rounds.button1Round}
          margin={{ top: index === 0 ? 'xs' : '0px' }}
          pad={{ vertical: 's', horizontal: 'l' }}
          direction="row"
          align="center"
        >
          <Box height="24px" direction="row" align="center" width="60%">
            <Inscription size="12px" lineHeight="18px" style={{ fontWeight: 500 }}>{item.validFrom}</Inscription>
            &nbsp;-&nbsp;
            <Inscription size="12px" lineHeight="18px" style={{ fontWeight: 500 }}>{item.validTo}</Inscription>
          </Box>

          <Box height="24px" direction="row" align="center" width="40%">
            <Inscription size="12px" lineHeight="18px" style={{ fontWeight: 500 }}>
              {item.amount !== null ? formatCurrency(item.amount) : 'N/A'}
            </Inscription>
          </Box>
        </Wrapper>
      ))}
    </Box>
  );
};

export default ElectionAmountTable;
